import './main.scss';

import Vue from 'vue';
import VueCookies from 'vue-cookies';
import { BIcon, BIconChevronLeft, BIconChevronRight, BIconRssFill, BootstrapVue } from 'bootstrap-vue';

const icons = {
  BIcon,
  BIconChevronLeft,
  BIconChevronRight,
  BIconRssFill
};

// @ts-ignore
import Affix from 'vue-affix';
// @ts-ignore
import breakpoints from '@eli5/bootstrap-breakpoints-vue';

import Navbar from '@/components/Navbar.vue';
// import LightboxGallery from '@/components/LightboxGallery.vue';
import MediumZoomGallery from '@/components/MediumZoomGallery.vue';
import ContactsForm from '@/components/ContactsForm.vue';
import DateTime from '@/components/DateTime.vue';
import RateDisplay from '@/components/RateDisplay.vue';
import BlogDateFilter from '@/components/BlogDateFilter.vue';
import BlogFilterForm from '@/components/BlogFilterForm.vue';
import BlogComments from '@/components/BlogComments.vue';
import CarouselSource from '@/components/CarouselSource.vue';

Vue.config.productionTip = process.env.NODE_ENV === 'production';

Vue.use(VueCookies);
Vue.use(BootstrapVue);
Vue.use(Affix);
Vue.use(breakpoints);

Vue.$cookies.config('1y');

document.addEventListener('DOMContentLoaded', () => {
  const app = new Vue({
    components: {
      ...icons,
      Navbar,
      // LightboxGallery,
      MediumZoomGallery,
      ContactsForm,
      DateTime,
      RateDisplay,
      BlogDateFilter,
      BlogFilterForm,
      BlogComments,
      CarouselSource
    }
  });
  app.$mount('#frontend');
});
